import React, {FC} from "react"

import {User} from "@irati/types"

import Profile from "./WithProfile"
import Image from "./WithImage"

export interface Props {
  image?: string,
  alt?: string,
  user?: User,
  size?: number,
  alignLeft?: boolean,
  backgroundColor?: string
}

const ModalHeader: FC<Props> = ({image, user, size, alt, alignLeft, backgroundColor}) => {
  return (
    <>
      {image && <Image image={image} size={size} alt={alt} alignLeft={alignLeft} backgroundColor={backgroundColor} />}
      {user && <Profile user={user} size={size} />}
    </>
  )
}

export default ModalHeader
